import { setLocalStorage } from '@/util/index.js'
import request from '@/api/request'


// 设置超时是否展示队列
export default class {
  list = []
  // 其中两个api分别为:
  // VUE_APP_ENV_API_HOST = "https://api-gateway.hzmantu.com/"
  // VUE_APP_ENV_API_HOST_2 = "https://gateway.hzmantu.com/"

  urlList = [process.env.VUE_APP_ENV_API_HOST, process.env.VUE_APP_ENV_API_HOST_2]

  constructor() {
    //
  }

  // 校验单个接口重复次数
  checkLoopOut(url) {
    const index = this.list.indexOf(url)
    if (index >= 0) {
      return true
    } else if (index < 0) {
      this.list.push(url)
      return false
    }
  }

  // NetworkError 处理逻辑
  async dealNetWorkError(error) {
    if (this.judgeBol(error?.message)) { // 判断是否为网络超时
      // 获取重发的信息
      const baseUrl = error?.config?.baseURL
      const params = error?.config?.params || error?.config?.data
      const method = error?.config?.method
      const url = error?.config?.url.replace(baseUrl, '')

      // 设置新的BaseUrl
      let newUrl = this.urlList[0]
      if (this.urlList[0].includes(baseUrl)) newUrl = this.urlList[1]
      // 缓存时间24小时
      setLocalStorage('flyConfigBaseURL', newUrl, 24 * 3600000)
      return { bol: true, repeatData: { params, method, url }, url: newUrl }
    } else {
      return { bol: false }
    }
  }

  // 布尔判断是否NetworkError
  judgeBol(message) {
    if (!message) return false
    return (
      message.includes('Network Error') ||
      message.includes('request:fail') ||
      message.includes('timeout')
    )
  }

  // 重发结束后删除存储的list
  deleteUrlFromList(error) {
    const url = error?.config?.url || ''
    const status = error?.request?.body?.status || ''
    // 添加status兼容订单同时调用两个接口的问题
    const index = this.list.indexOf(url + status)
    if (index >= 0) this.list.splice(index, 1)
    // this.list = _.filter(_.map(this.list, item => item === url ? '' : url),  ele => ele )
  }

  // 重发原接口
  async setRepeatApi({ method, url, params }) {
    const data = await request(method, url, params)
    return data
  }
}
